import { useEffect, useRef, useState } from "react";
import "./rating-dialog-style.css";

const RatingDialog = ({ open, onClose, onSuccess }) => {
  const [stars, setStars] = useState(0);
  const [feedback, setFeedback] = useState("");

  // 鎖背景滾動 + ESC 關閉
  useEffect(() => {
    if (!open) return;

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    const prevOverflow = document.body.style.overflow;
    const prevPaddingRight = document.body.style.paddingRight;

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
  }, [open, onClose, onSuccess]);

  if (!open) return null;

  const submitFeedback = () => {
    onSuccess?.(stars, feedback);
    onClose();
  };

  return (
    <div className="rating-backdrop" onMouseDown={onClose}>
      <div className="rating-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="close-btn" onClick={onClose}>
          <img src={`/images/ic-white-close.png`} alt="close" />
        </div>

        <div className="rating-content">
          <div className="stars">
            {/* 滿星 */}
            {Array.from({ length: stars }).map((_, i) => (
              <img
                onClick={() => {
                  setStars(i + 1);
                }}
                src="../images/ic-brown-fill-star.png"
              />
            ))}

            {/* 空星 */}
            {Array.from({ length: 5 - stars }).map((_, i) => (
              <img
                onClick={() => {
                  setStars(i + stars + 1);
                }}
                src="../images/ic-brown-empty-star.png"
              />
            ))}
          </div>
          <span>對此則回覆給予評分及回饋</span>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="寫下回饋內容"
          ></textarea>
          <span
            className={`submit ${stars > 0 ? "allow-submit" : ""}`}
            onClick={stars > 0 ? submitFeedback : undefined}
          >
            送出
          </span>
        </div>
      </div>
    </div>
  );
};

export default RatingDialog;
